var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#18397A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13653_39415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7712 22.5523C16.7703 22.7525 16.6903 22.9441 16.5488 23.0856C16.4073 23.2272 16.2156 23.3071 16.0155 23.308C15.8161 23.3047 15.6258 23.224 15.4848 23.083C15.3438 22.942 15.2631 22.7517 15.2598 22.5523L15.2664 16.7555L9.46955 16.7621C9.27017 16.7587 9.07989 16.6781 8.93888 16.537C8.79788 16.396 8.71718 16.2058 8.71383 16.0064C8.71479 15.8062 8.79472 15.6146 8.93624 15.4731C9.07775 15.3315 9.26942 15.2516 9.46955 15.2507L15.2664 15.2573L15.2598 9.46044C15.2782 9.27283 15.3658 9.0988 15.5055 8.97219C15.6452 8.84559 15.827 8.77547 16.0155 8.77547C16.204 8.77547 16.3858 8.84559 16.5255 8.97219C16.6651 9.0988 16.7527 9.27283 16.7712 9.46044L16.7646 15.2573L22.5614 15.2507C22.749 15.2691 22.9231 15.3567 23.0497 15.4964C23.1763 15.6361 23.2464 15.8179 23.2464 16.0064C23.2464 16.1949 23.1763 16.3767 23.0497 16.5164C22.9231 16.656 22.749 16.7436 22.5614 16.7621L16.7646 16.7555L16.7712 22.5523Z",
    fill: "#18397A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13653_39415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayPlus);
export default __webpack_public_path__ + "static/media/gray-plus.cacca61c986ec653ff5e2aaf166f7b85.svg";
export { ForwardRef as ReactComponent };